import {Fragment, useEffect, useState} from "react";
import {markDirty, showError, showMessage} from "../js/main";
import {getResponseBody, getResponseStatus, handleApiError, handleExpiredEntryLinkError, post} from "../js/api";
import {Button} from "./form/Button";
import {useTanConfirmation} from "../js/useTanConfirmation";
import {TanValidity} from "./TanValidity";
import {orderType} from "../js/constants";
import {isValidTan, sanitizeTan, TanInput} from "./form/TanInput";

const getWording = (order) => {
    return order.type == orderType.request ? "Anfrage" : "Bestellung";
}

export const SignOrder = ({children, order, orderToken, signed, canceled, tanFailed, isPublic, cancelable, initialTan = ""}) => {

    const orderIdentifier = isPublic ? orderToken : order?.id;
    const [submitting, setSubmitting] = useState(false);
    const {signatureCode, setSignatureCode, tanStatus, tanBusy, requestNewTan, handleTanError} = useTanConfirmation({
        path: `${isPublic ? "/public" : ""}/orders/${orderIdentifier}`,
        enabled: order?.state === "CREATED",
        submitting,
        initialTan
    });

    const [canCancel, setCanCancel] = useState(true && cancelable)

    useEffect(() => {
        if(order){
            setCanCancel(["CREATED", "AWAIT_PAYMENT"].indexOf(order.state) != -1 && cancelable);
        }

    }, [order]); // eslint-disable-line react-hooks/exhaustive-deps

    const signOrder = () => {
        if (submitting || tanBusy || !tanStatus) return;
        const tan = sanitizeTan(signatureCode);
        setSignatureCode(tan);
        if (!isValidTan(tan)) {
            showError("Bitte geben Sie den 6-stelligen Code ein.");
            return;
        }

        setSubmitting(true);

        const orderIdentifier = isPublic ? orderToken : order.id;
        const req = {
            tan
        };

        post((isPublic ? "/public":"") + "/orders/" + orderIdentifier + "/signOrder", req, false).then((resp) => {
            showMessage("Die "+getWording(order)+" wurde erfolgreich bestätigt.");
            signed(resp);
        }).catch(async err => {
            if (handleExpiredEntryLinkError(err)) {
                return;
            }
            if (await handleTanError(err)) return;
            setSignatureCode("");
            let msg = "Der eingegebene Code war nicht korrekt.";
            if (getResponseStatus(err) === 422) {
                switch (getResponseBody(err)?.errorType) {
                    case "RETRY":
                        msg += " Bitte versuchen Sie es erneut.";
                        break;
                    case "FAIL":
                        msg += " Die  "+getWording(order)+" wurde storniert.";
                        tanFailed();
                        break;
                    default:
                        break;
                }
                showError(msg);
                return;
            }
            handleApiError(err);
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const cancelOrder = () => {
        setSubmitting(true);
        const orderIdentifier = isPublic ? orderToken : order.id;
        post((isPublic ? "/public":"") +"/orders/" + orderIdentifier + "/cancelOrder", null, false).then(() => {
            markDirty();
            showMessage("Die "+getWording(order)+" wurde erfolgreich storniert.");
            canceled();
        }).catch(err => {
            if (!handleExpiredEntryLinkError(err)) {
                handleApiError(err);
            }
        }).finally(() => {
            setSubmitting(false);
        });
    };

    return (
        <Fragment>
            {order &&
                <div>
                    {order.state === "CREATED" &&
                        <div className="zeichnung mt-2 mb-2">
                            <h2 className="primary-link mt-0">{getWording(order)} autorisieren</h2>
                            <p>
                                <strong>Sie haben den Bestätigungscode per Mail erhalten. Überprüfen Sie Ihren Spam-Ordner!</strong> Mit Eingabe des
                                Codes wird die {getWording(order)} abgeschickt. Sie stimmen damit unseren AGB zu{order.type != orderType.request && <> und es wird ein rechtsgültiges Geschäft
                                abgeschlossen.</>} Der Code besteht nur aus Zahlen.
                            </p>
                            <form onSubmit={event => {
                                event.preventDefault();
                                signOrder();
                            }}>
                                <TanInput value={signatureCode} setter={setSignatureCode}/>
                                <TanValidity status={tanStatus} busy={tanBusy}/>
                                <Button submitting={submitting || tanBusy || !tanStatus} width={220} theme="green mr-1 mb-05">{getWording(order)} bestätigen</Button>
                                <Button submitting={submitting || tanBusy} width={230} type="button" onClick={() => requestNewTan()} theme="orange mb-05">Neuen Code anfordern</Button>
                            </form>
                        </div>}

                    {children}

                    {canCancel && <form onSubmit={e => {e.preventDefault();}} className="storno mt-2 ">
                        <h3 className="red mt-0">{getWording(order)} stornieren</h3>
                        <p>
                            Wenn Sie die {getWording(order)} stornieren, kann das nicht mehr widerrufen werden. Wenn Sie die {getWording(order)} später dennoch
                            durchführen wollen, muss eine neue {getWording(order)} erstellt werden. Nach der Zeichnung kann die {getWording(order)} nur mehr von
                            Mitarbeitern der Lintner GmbH storniert werden. Setzen Sie sich hierfür bei Bedarf mit dem Kundenservice in
                            Kontakt.
                        </p>
                        <Button submitting={submitting} width={230} theme="red" onClick={() => cancelOrder()}>{getWording(order)} stornieren</Button>
                    </form>}

                    <br/><br/>
                </div>}
        </Fragment>
    );

};
